module.exports = __webpack_public_path__ + "media/images/background/background-1-d63ab02923cf06d2356b86ac80180389.jpg";